import { createAsyncThunk } from '@reduxjs/toolkit';

import { DriverDocType } from '@/modules/driver/model/driver-doc-type';
import { namespace } from '@/modules/driver/namespace';
import {
  driverUploadSelectors,
  myDriverUploadSelectors,
} from '@/modules/driver/store/upload-slice';
import type { RootState } from '@/root-store';
import { ThunkResult } from '@/shared/actions/thunk-result';

import { updateUploadFormValue, updateMyDriverUploadFormValue } from '../actions';

let lastRequestId: string | undefined;

type Params = {
  docType: DriverDocType;
  onSuccess?: () => void;
};

const createPrepareUploadDriverForm = (ownDriver: boolean) =>
  createAsyncThunk(
    `${namespace}/prepare-upload-${ownDriver ? 'my' : ''}driver-form`,
    async (
      { docType, onSuccess }: Params,
      { getState, dispatch, requestId },
    ): Promise<ThunkResult> => {
      lastRequestId = requestId;

      if (lastRequestId !== requestId) {
        return { isReplaced: true };
      }

      const updateUploadFormValueActionCreator = ownDriver
        ? updateMyDriverUploadFormValue
        : updateUploadFormValue;

      dispatch(updateUploadFormValueActionCreator({ docType }));

      const values = (
        ownDriver ? myDriverUploadSelectors : driverUploadSelectors
      ).getValuesForUploadForm(getState() as RootState);

      dispatch(
        updateUploadFormValueActionCreator({
          expiresAt: values?.expiresAt,
          file: values?.file,
          status: values?.status,
          rejectReason: values?.rejectReason,
        }),
      );

      onSuccess?.();

      return { isSucceed: true };
    },
  );

const prepareUploadDriverForm = createPrepareUploadDriverForm(false);
const prepareUploadMyDriverForm = createPrepareUploadDriverForm(true);

export { prepareUploadDriverForm, prepareUploadMyDriverForm };
